import { render, staticRenderFns } from "./mc-toast.tests.vue?vue&type=template&id=5fd52281&scoped=true"
import script from "./mc-toast.tests.vue?vue&type=script&lang=ts"
export * from "./mc-toast.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd52281",
  null
  
)

export default component.exports